const advanceInvoiceInstallment = {
  'advanceInvoiceInstallment.title': 'Advance Invoice Installment',
  'advanceInvoiceInstallment.emptyState':
    "There's no invoice installment to advance.",
  'advanceInvoiceInstallment.errorState':
    "We couldn't fetch invoice installment data.",
  'advanceInvoiceInstallment.confirm': 'Confirm',
  'advanceInvoiceInstallment.outcomeSuccess': 'Invoice Installment advanced',
  'advanceInvoiceInstallment.close': 'Close',

  'advanceInvoiceInstallment.firstPaymentDate': 'First payment date',
  'advanceInvoiceInstallment.firstPaymentAmount': 'First installment amount',
  'advanceInvoiceInstallment.numberInstallments': 'Number of installments',
  'advanceInvoiceInstallment.contractAmount': 'Contract amount',
  'advanceInvoiceInstallment.principalAmount': 'Principal amount',
  'advanceInvoiceInstallment.installmentAmount': 'Installment amount',
  'advanceInvoiceInstallment.interestRate': 'Interest rate',

  'advanceInvoiceInstallment.noAdvanceInvoiceInstallmentOptions':
    'There is no advance invoice installment options',
  'advanceInvoiceInstallment.installmentsToAdvance': 'Installments to advance',
  'advanceInvoiceInstallment.totalAmount': 'Total amount',
  'advanceInvoiceInstallment.inAdvance': 'In advance',
};

export default advanceInvoiceInstallment;
